import React from 'react'
import '../Assets/Css/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'
import { FaLocationDot } from "react-icons/fa6";
import { FaMobileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebookF } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";



export default function WebFooter() {


  return (
    <>

      <Col lg={12}>
        <div className='p-1 ' style={{ backgroundColor: '#20B2AA' }}>
          <Container>
            <Row className='mt-3'>
              <Col lg={5}  >
               <h5 className="fw-bold text-white " >Sense Technologies, Inc.</h5>
  <p className="mb-0 text-white" >
    Sense Technologies, Inc. blends advanced sensing systems with nature-based innovations to create sustainable, real-world solutions. From radar to nutrition, we are committed to precision, purity, and purpose.
  </p>
               



              </Col>

              <Col lg={3}>
  <h5 className='text-white'>Quick Links</h5>
  <ul className="list-unstyled text-white quick-links">
    <li>
      <MdKeyboardDoubleArrowRight />
      <a href="/" className="text-white text-decoration-none"> Home</a>
    </li>
    <li>
      <MdKeyboardDoubleArrowRight />
      <a href="/#about" className="text-white text-decoration-none"> About Us</a>
    </li>
    <li>
      <MdKeyboardDoubleArrowRight />
      <a href="/#technologies" className="text-white text-decoration-none"> Technologies</a>
    </li>
    <li>
      <MdKeyboardDoubleArrowRight />
      <a href="/#contact" className="text-white text-decoration-none"> Contact Us</a>
    </li>
  </ul>
</Col>



              <Col lg={4}>
             
 <h5 className='text-white'> Contact</h5>
 <div className='d-flex '>
                  <a
                    href="david@sensenaturalproducts.com"
                    style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >
                    <span className='text-white'>
                      < MdEmail color='white' /> david@sensenaturalproducts.com
                    </span>
                  </a>

                </div>

                <div className='d-flex'>
                  <span><FaLocationDot color='white' /></span>
                  <a
                    href='https://maps.app.goo.gl/a6EoofWWzXSf2dmX7'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white ms-2 text-decoration-none'
                  >
                  Texas 75077, USA


                  </a>
                </div>
               

              </Col>
            </Row>

            <div className='text-white mt-3 footerend text-center'>
              <hr />
              <p>© {new Date().getFullYear()} <strong>Sense Technologies, Inc.</strong> |
                <a href="https://www.bighostindia.in/" style={{ color: 'white', textDecoration: 'none' }}> Design By : BigHost India Private Limited</a> </p>
            </div>
          </Container>
        </div>
      </Col>


    </>
  )
}
